import styled, { css } from 'styled-components';
import PrivacyIcon from '../../../../search/PrivacyInfo/PrivacyIcon.svg';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  FontSize,
  FontWeight,
  FONT_STACK,
  PRESSABLE_LINK,
  ZIndex,
} from '../../../styles/constants';
import { Button as BaseButton } from '../../Button/Button';
import { Link } from '../../Link';
import { IconHealthEngine as BaseIconHealthEngine } from '../../icons/IconHealthEngine';

export const DesktopNavMenuContainer = styled.div<{ searchExperimentRunning?: boolean }>`
  ${({ searchExperimentRunning }) =>
    searchExperimentRunning &&
    css`
      align-items: center;
      display: flex;
      flex: 2;
      justify-content: right;
    `}
`;

export const Links = styled.div`
  ${FONT_STACK}
  align-items: center;
  display: flex;
`;

export const StyledLink = styled(Link)`
  ${PRESSABLE_LINK};
  align-items: center;
  color: ${ThemeColours.black};
  display: flex;
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  margin: 0 12px;
  text-align: center;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const HoverButton = styled(BaseButton)`
  background: none;
  color: ${ThemeColours.black};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const IconHealthEngine = styled(BaseIconHealthEngine)`
  margin-right: 4px;
`;

export const Button = styled(BaseButton)`
  font-size: 16px;
  height: 44px;
  margin: 0 0 0 12px;
  text-align: center;
  width: auto;
`;

export const PrivacyIconContainer = styled.a`
  margin: 0 12px;

  &:focus {
    box-shadow: 0 0 0 2px ${ThemeColours.primary700};
    outline: none;
  }
`;

export const StyledPrivacyIcon = styled(PrivacyIcon)`
  height: 28px;
  width: 28px;
`;

export const LoginDropdown = styled.div`
  background-color: ${ThemeColours.white};
  border-radius: 12px;
  box-shadow: 0 0 42px -18px ${ThemeColours.mono400};
  display: none;
  flex-direction: column;
  padding: 8px;
  position: absolute;
  right: 0;
  top: 100%;
  white-space: nowrap;
  z-index: ${ZIndex.POPUP};
`;

export const LoginDropdownItem = styled(StyledLink)`
  border-radius: 4px;
  font-weight: ${FontWeight.REGULAR};
  margin: 0;
  padding: 12px 24px;
  text-decoration: none;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${ThemeColours.mono100};
    color: ${ThemeColours.linkHover};
    text-decoration: none;
  }
`;

export const LoginWrapper = styled.div`
  position: relative;
  &:hover {
    ${LoginDropdown} {
      display: flex;
    }
  }
`;
